import throttle from 'lodash.throttle';
import debounce from 'lodash.debounce';

export default class Dropin {
	constructor(dropin, container, parent) {
		this.dropin = dropin;
		this.parent = parent;
		if(container) {
			this.container = container;
		}

		this.init();
	}

	init() {
		if (!this.container) {
			return;
		}

		const dataElm = this.container.querySelector('#container-data');
		if(!dataElm) {
			return;
		}

		this.data = JSON.parse(dataElm.innerHTML);
		if (!this.dropin || !this.data) {
			return;
		}
		this.type = this.dropin.dataset.dropintype;
		if (!this.type) {
			return;
		}
		this.dataset = this.data[this.type];
		if (!this.dataset) {
			return;
		}
		this.enabled = this.dataset.enabled;
		if (!this.enabled) {
			return;
		}

		// Bind Scroll Event
		this.boundScrollListener = throttle(
			this.scrollListener.bind(this),
			100
		);
		document.addEventListener(
			'scroll',
			this.boundScrollListener
		);
		// Bind Resize Event
		this.boundResizeListener = debounce(
			this.resizeListener.bind(this),
			400
		);
		window.addEventListener(
			'resize',
			this.boundResizeListener
		);
		// Bind After Listener
		this.boundAfterListener = this.afterListener.bind(this);
		document.addEventListener('after', this.boundAfterListener);

        document.fonts.ready.then(() => {
            this.setStartStop();
		});

		this.active = true;
	}

	scrollListener(e) {
		if(this.dropin) {
			this.checkScroll();
		}
	}

	resizeListener(e) {
		if (this.dropin) {
			this.setStartStop();
		}
	}

	afterListener() {
		if(this.dropin) {
			this.setStartStop();
		}
		document.removeEventListener('after', this.boundAfterListener);
	}

    setStartStop() {
		if(!this.dataset) {
			return;
		}
		const start = parseInt(this.dataset.show, 10);
		const stop = parseInt(this.dataset.hide, 10);

		this.calculatePositions(start, stop);
    }

    calculatePositions(start, stop) {
		const height = document.documentElement.scrollHeight;

		this.positions = {
			start: Math.floor((height / 100) * start),
			stop: Math.floor((height / 100) * stop),
		};

		this.checkScroll();
    }

    checkScroll() {
		if (!this.positions) {
			return;
		}

        let viewportBottom = window.scrollY + window.innerHeight;
		if (viewportBottom < this.positions.start || viewportBottom > this.positions.stop) {
			this.hide();
		} else {
			this.show();
		}
    }

    show() {
		this.parent.show();
	}

	hide() {
		this.parent.hide();
	}

	destroy() {
		document.removeEventListener('scroll', this.boundScrollListener);
		window.removeEventListener('resize', this.boundResizeListener);
		this.active = false;
	}

}
